import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=7454c9c6&scoped=true&"
import script from "./confirm.vue?vue&type=script&lang=js&"
export * from "./confirm.vue?vue&type=script&lang=js&"
import style0 from "./confirm.vue?vue&type=style&index=0&id=7454c9c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7454c9c6",
  null
  
)

export default component.exports